"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "htm": "text/html",
    "html": "text/html",
    "json": "application/ld+json",
    "jsonld": "application/ld+json",
    "n3": "text/n3",
    "nq": "application/n-quads",
    "nquads": "application/n-quads",
    "nt": "application/n-triples",
    "ntriples": "application/n-triples",
    "owl": "application/rdf+xml",
    "rdf": "application/rdf+xml",
    "rdfxml": "application/rdf+xml",
    "shaclc": "text/shaclc",
    "shaclce": "text/shaclc-ext",
    "shc": "text/shaclc",
    "shce": "text/shaclc-ext",
    "svg": "image/svg+xml",
    "svgz": "image/svg+xml",
    "trig": "application/trig",
    "ttl": "text/turtle",
    "turtle": "text/turtle",
    "xht": "application/xhtml+xml",
    "xhtml": "application/xhtml+xml",
    "xml": "application/xml"
};
//# sourceMappingURL=mediaMappings.js.map